<template>
	<picture>
		<source :srcSet="srcWebp" type="image/webp" />
		<img
			src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
			:data-src="fullSrcUrl"
			:class="{ absolute: absolute }"
		/>
	</picture>
</template>

<script>
export default {
	name: 'CdnImage',
	props: {
		src: {
			type: String,
			required: true,
		},
		srcWidth: {
			type: Number,
			default: 10000,
		},
		responsiveWidths: {
			type: Array,
			default: () => [],
		},
		absolute: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		fullSrcUrl() {
			if (!this.src) return '';
			return this.cdnHost + this.src;
		},
		srcWebp() {
			const pos = this.fullSrcUrl.lastIndexOf('.'),
				fileName = this.fullSrcUrl.substr(0, pos);
			return `${fileName}.webp`;
		},
		// srcsetWebp() {
		// 	if (!this.src) return '';
		// 	const pos = this.fullSrcUrl.lastIndexOf('.'),
		// 		fileName = this.fullSrcUrl.substr(0, pos),
		// 		defaultSrcset = `${fileName}.webp` + (this.srcWidth ? ` ${this.srcWidth}w` : '');

		// 	return this.responsiveWidths.reduce((accumulator, width) => {
		// 		return accumulator + `, ${fileName}_${width}w.webp ${width}w`;
		// 	}, defaultSrcset);
		// },
	},
};
</script>

<style scoped>
img {
	top: 50%;
	left: 50%;
	position: relative;
	transform: translate(-50%, -50%);
	height: 100%;
	width: auto;
}
img.absolute {
	position: absolute;
}
</style>
